export { default } from "./SettingsLicense";
export * from "./SettingsLicense.styled";
